import { addDays, addMonths, startOfWeek, endOfWeek } from 'date-fns';
import { dateToIsoKey } from '../../../../utils/availabilityStatus';

/** Arrow / page keys that can move focus to another calendar day. */
export const DAY_NAV_KEYS = new Set([
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
  'PageUp',
  'PageDown',
]);

/**
 * Target day for MUI-style day-grid keyboard navigation (LTR).
 * @param {string} key
 * @param {Date} day
 * @returns {Date|null}
 */
export const getDayNavigationTarget = (key, day) => {
  switch (key) {
    case 'ArrowUp':
      return addDays(day, -7);
    case 'ArrowDown':
      return addDays(day, 7);
    case 'ArrowLeft':
      return addDays(day, -1);
    case 'ArrowRight':
      return addDays(day, 1);
    case 'Home':
      return startOfWeek(day);
    case 'End':
      return endOfWeek(day);
    case 'PageUp':
      return addMonths(day, 1);
    case 'PageDown':
      return addMonths(day, -1);
    default:
      return null;
  }
};

/**
 * Focus the visible (in-month) day button for `day`, if mounted.
 * @param {Date} day
 */
export const focusVisibleCalendarDayButton = (day) => {
  const el = document.querySelector(
    `button[data-calendar-day="${dateToIsoKey(day)}"]`
  );
  if (!el) return;
  el.focus();
  el.scrollIntoView({ block: 'nearest' });
};
